import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { provideNzIcons } from 'ng-zorro-antd/icon';
import { SearchOutline, DownOutline } from '@ant-design/icons-angular/icons';

bootstrapApplication(App, {
  ...appConfig,
  providers: [
    ...(appConfig.providers ?? []),
    provideAnimations(),
    provideNzIcons([SearchOutline, DownOutline]),
  ],
}).catch((err) => console.error(err));
